import React from 'react'
import { useTranslation } from 'react-i18next'
import { EmptyState, RowsSkeletonLoader } from '@node-space/ui-components'
import { PageHeader } from 'components/header/PageHeader'
import { useHppPaymentMethodsQuery } from 'hooks/queries/useHppPaymentMethodsQuery'
import { useHppRemoteWalletProvidersQuery } from 'hooks/queries/useHppRemoteWalletProvidersQuery'
import { RemoteWalletProviderItem } from 'types/hppSettings'
import { HppSettingsForm } from './HppSettingsForm'
import { paymentMethodsToFormValue } from './utils'

const emptyArr: RemoteWalletProviderItem[] = []

export const HppSettings = () => {
  const { t } = useTranslation()

  const {
    data: paymentMethodsData,
    isLoading: isLoadingMethods,
    isError: isErrorMethods,
  } = useHppPaymentMethodsQuery()
  const {
    data: providersData,
    isLoading: isLoadingProviders,
    isError: isErrorProviders,
  } = useHppRemoteWalletProvidersQuery()

  const isLoading = isLoadingMethods || isLoadingProviders
  const hasData = paymentMethodsData !== undefined && providersData !== undefined
  const isError = isErrorMethods || isErrorProviders || (!isLoading && !hasData)

  return (
    <>
      <PageHeader description={t('hppSettings.subtitle')} />
      {isError ? (
        <EmptyState testId="hpp-settings-error" title={t('hppSettings.dataError')} />
      ) : (
        <>
          {isLoading ? (
            <RowsSkeletonLoader rows={5} />
          ) : (
            <HppSettingsForm
              paymentMethod={paymentMethodsToFormValue(paymentMethodsData?.types)}
              remoteWalletProviders={providersData?.content ?? emptyArr}
            />
          )}
        </>
      )}
    </>
  )
}
